import { render, staticRenderFns } from "./CriticalEngagementsItemInformation.vue?vue&type=template&id=c953984c&"
import script from "./CriticalEngagementsItemInformation.vue?vue&type=script&lang=js&"
export * from "./CriticalEngagementsItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports